import { Link, Outlet } from 'react-router-dom';
import { TESTFLIGHT_URL } from '../lib/platform';

export default function Layout() {
  return (
    <div className="min-h-full flex flex-col">
      <header className="sticky top-0 z-30 border-b border-djinn-border bg-djinn-bg/95 backdrop-blur-md">
        <div className="site-width flex min-h-18 items-center gap-2 sm:gap-5">
          <Link to="/" className="flex shrink-0 items-center gap-1.5 sm:gap-2.5" aria-label="DJINN home">
            <img src="/djinn-D.png" alt="" className="h-9 w-auto sm:h-11" />

          </Link>
          <div className="ml-auto flex items-center gap-2 sm:gap-5">
            <a href={TESTFLIGHT_URL} target="_blank" rel="noopener noreferrer" className="whitespace-nowrap rounded-xl bg-djinn-cyan px-3 py-2.5 text-xs font-bold text-djinn-bg transition hover:bg-[#9cecf3] sm:px-5 sm:py-3 sm:text-sm">Join the beta <span aria-hidden="true" className="ml-1 sm:ml-2">→</span></a>
            <Link to="/support" className="whitespace-nowrap text-xs text-djinn-text-2 transition hover:text-djinn-text sm:text-sm">Support</Link>
          </div>
        </div>
      </header>
      <main className="flex-1"><Outlet /></main>
      <footer className="border-t border-djinn-border bg-djinn-bg">
        <div className="site-width grid gap-9 py-12 sm:grid-cols-[1fr_auto]">
          <div><Link to="/" className="text-2xl font-extrabold tracking-[-0.08em] text-djinn-text">DJINN.</Link><p className="mt-3 text-sm text-djinn-text-muted">Train smarter. Get stronger.</p></div>
          <nav aria-label="Footer navigation" className="flex flex-wrap items-start gap-x-7 gap-y-3 text-sm text-djinn-text-2">
            <Link to="/support" className="hover:text-djinn-cyan">Support</Link><Link to="/privacy" className="hover:text-djinn-cyan">Privacy</Link><Link to="/terms" className="hover:text-djinn-cyan">Terms</Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}
